import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function Services() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState('');

  const openLightbox = (imageSrc: string) => {
    setLightboxImage(imageSrc);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage('');
  };

  const services = [
    {
      icon: 'ri-tent-line',
      name: 'Körüklü Tente',
      description: 'Esnek kol mekanizması ile kolay kullanım sağlayan, balkon ve teraslarda en çok tercih edilen klasik tente sistemi',
      slug: 'koruklu-tente',
      image: 'https://public.readdy.ai/ai/img_res/a2471ada9c5f2c4edd9a6ecad38580b7.jpg',
      excerpt: 'Balkon ve teraslarda en çok tercih edilen esnek kol mekanizmalı tente sistemi',
    },
    {
      icon: 'ri-building-line',
      name: 'Mafsallı Tente',
      description: 'Geleneksel mafsal mekanizması ile işletmelere nostaljik ve zarif görünüm kazandıran klasik tente modeli',
      slug: 'mafsalli-tente',
      image: 'https://readdy.ai/api/search-image?query=High%20quality%20articulated%20joint%20awning%20with%20robust%20mechanical%20arm%20system%2C%20premium%20weather%20resistant%20striped%20canvas%20in%20classic%20colors%2C%20professional%20installation%20on%20residential%20terrace%2C%20traditional%20elegant%20style%2C%20reinforced%20metal%20framework%2C%20simple%20light%20background%20showcasing%20the%20awning%20details&width=400&height=300&seq=mafser1&orientation=landscape',
      excerpt: 'İşletmelere nostaljik ve zarif görünüm kazandıran geleneksel tente modeli',
    },
    {
      icon: 'ri-compass-line',
      name: 'Otomatik Pergola',
      description: 'Uzaktan kumanda ile kontrol edilen, akıllı sensörlerle donatılmış modern pergola sistemi',
      slug: 'otomatik-pergola',
      image: 'https://readdy.ai/api/search-image?query=Motorized%20automatic%20pergola%20system%20with%20remote%20control%20operation%2C%20sleek%20contemporary%20design%20with%20retractable%20roof%20panels%2C%20aluminum%20structure%20in%20modern%20finish%2C%20integrated%20electric%20motor%2C%20smart%20outdoor%20solution%2C%20simple%20neutral%20background%20emphasizing%20technology&width=400&height=300&seq=otoser1&orientation=landscape',
      excerpt: 'Uzaktan kumanda ile kontrol edilen akıllı sensörlü modern pergola',
    },
    {
      icon: 'ri-home-gear-line',
      name: 'Bioklimatik Pergola',
      description: 'Döner lamel sistemi ile hava akışını ve ışık miktarını tam kontrole olanak tanıyan lüks pergola',
      slug: 'bioklimatik-pergola',
      image: 'https://readdy.ai/api/search-image?query=Modern%20bioclimatic%20pergola%20system%20installed%20in%20a%20luxury%20outdoor%20living%20space%20with%20motorized%20rotating%20louvers%20providing%20adjustable%20shade%20control%2C%20featuring%20sleek%20aluminum%20frame%20in%20anthracite%20gray%20finish%2C%20integrated%20LED%20lighting%20strips%2C%20clean%20minimalist%20design%2C%20contemporary%20architectural%20style%2C%20simple%20light%20neutral%20background%20emphasizing%20the%20structure&width=400&height=300&seq=bioser1&orientation=landscape',
      excerpt: 'Döner lamel sistemi ile hava ve ışık kontrolü sağlayan lüks pergola',
    },
    {
      icon: 'ri-landscape-line',
      name: 'Zip Perde',
      description: 'Yan yönlendirme raylı, rüzgara karşı maksimum dayanıklılık sunan dikey gölgelendirme sistemi',
      slug: 'zip-perde',
      image: 'https://readdy.ai/api/search-image?query=Modern%20zip%20screen%20roller%20blind%20system%20with%20guided%20side%20channels%2C%20transparent%20weather%20resistant%20fabric%2C%20sleek%20vertical%20installation%20on%20terrace%2C%20windproof%20design%20with%20aluminum%20tracks%2C%20contemporary%20style%2C%20minimal%20background%20highlighting%20the%20screen%20system&width=400&height=300&seq=zipser1&orientation=landscape',
      excerpt: 'Rüzgara karşı maksimum dayanıklılık sunan yan raylı dikey perde',
    },
    {
      icon: 'ri-shield-line',
      name: 'Şeffaf Stor',
      description: 'Manzarayı kapatmadan rüzgar ve yağmurdan koruyan, şeffaf PVC malzemeli stor perde',
      slug: 'seffaf-stor',
      image: 'https://readdy.ai/api/search-image?query=Transparent%20PVC%20roller%20blind%20system%20for%20outdoor%20use%2C%20clear%20weather%20protection%20screen%2C%20modern%20vertical%20installation%2C%20see-through%20material%20maintaining%20view%2C%20professional%20grade%20quality%2C%20simple%20clean%20background%20showing%20the%20transparent%20screen&width=400&height=300&seq=storser1&orientation=landscape',
      excerpt: 'Manzarayı koruyarak rüzgar ve yağmurdan koruyan şeffaf stor',
    },
    {
      icon: 'ri-store-line',
      name: 'Fransız Tente',
      description: 'Kavisli tasarımı ve renkli desenleri ile cafe ve restoranların vazgeçilmezi olan Parisi tente',
      slug: 'fransiz-tente',
      image: 'https://readdy.ai/api/search-image?query=Classic%20French%20style%20awning%20with%20elegant%20curved%20shape%2C%20traditional%20striped%20canvas%20fabric%20in%20vibrant%20colors%2C%20decorative%20storefront%20installation%2C%20romantic%20bistro%20aesthetic%2C%20vintage%20charm%20with%20modern%20materials%2C%20simple%20background%20highlighting%20the%20French%20awning%20design&width=400&height=300&seq=fraser1&orientation=landscape',
      excerpt: 'Cafe ve restoranların vazgeçilmezi kavisli Parisi tente',
    },
    {
      icon: 'ri-inbox-line',
      name: 'Kasetli Tente',
      description: 'Kumaş ve mekanizmayı tam koruyan kapalı kasa tasarımı ile tentelerin en gelişmiş modeli',
      slug: 'kasetli-tente',
      image: 'https://readdy.ai/api/search-image?query=Premium%20cassette%20awning%20system%20with%20fully%20enclosed%20protective%20housing%2C%20sleek%20modern%20design%20with%20aluminum%20casing%20protecting%20fabric%20when%20retracted%2C%20integrated%20motor%2C%20high-end%20residential%20installation%2C%20contemporary%20minimalist%20style%2C%20simple%20background&width=400&height=300&seq=kasser1&orientation=landscape',
      excerpt: 'Tam korumalı kapalı kasa tasarımı ile en gelişmiş tente modeli',
    },
    {
      icon: 'ri-instance-line',
      name: 'Karpuz Tente',
      description: 'Kubbe şeklindeki karakteristik tasarımı ile pazar ve dükkanların geleneksel tente sistemi',
      slug: 'karpuz-tente',
      image: 'https://readdy.ai/api/search-image?query=Dome%20shaped%20watermelon%20style%20awning%20with%20curved%20semicircular%20design%2C%20striped%20colorful%20fabric%20pattern%2C%20traditional%20commercial%20storefront%20installation%2C%20rounded%20protective%20canopy%2C%20classic%20Mediterranean%20style%2C%20simple%20background%20showcasing%20the%20curved%20awning%20shape&width=400&height=300&seq=karser1&orientation=landscape',
      excerpt: 'Pazar ve dükkanların geleneksel kubbe şeklindeki tente sistemi',
    },
    {
      icon: 'ri-layout-grid-line',
      name: 'T Modül Tente',
      description: 'Modüler yapısı ile geniş açıklıkları ara destek olmadan kapatan yenilikçi tente sistemi',
      slug: 't-modul-tente',
      image: 'https://readdy.ai/api/search-image?query=Modern%20modular%20T-shaped%20awning%20system%20with%20innovative%20structural%20design%20featuring%20clean%20geometric%20lines%20and%20contemporary%20aluminum%20framework%2C%20sleek%20professional%20installation%20on%20commercial%20building%2C%20minimalist%20architectural%20integration%2C%20high-tech%20canopy%20solution%2C%20simple%20neutral%20background%20emphasizing%20the%20T-module%20structure&width=400&height=300&seq=tmodser1&orientation=landscape',
      excerpt: 'Geniş açıklıkları ara destek olmadan kapatan modüler tente',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24 md:pt-32 pb-12 md:pb-20">
        <div className="max-w-[1400px] mx-auto px-6">
          <header className="mb-8 md:mb-16 text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-primary mb-4">Hizmetlerimiz</h1>
            <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
              Bursa'da tente ve pergola sistemlerinde geniş ürün yelpazemizle ihtiyacınıza en uygun çözümü sunuyoruz
            </p>
          </header>

          <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
            {services.map((service) => (
              <article key={service.slug} className="group">
                <Link
                  to={`/hizmetler/${service.slug}`}
                  className="block bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-40 md:h-56 overflow-hidden">
                    <img
                      src={service.image}
                      alt={`Bursa ${service.name} Sistemleri`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 cursor-pointer"
                      loading="lazy"
                      onClick={(e) => {
                        e.preventDefault();
                        openLightbox(service.image);
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  </div>
                  <div className="p-4 md:p-6">
                    <h2 className="text-lg md:text-2xl font-bold text-primary mb-2 group-hover:text-secondary transition-colors">
                      {service.name}
                    </h2>
                    <p className="text-sm md:text-base text-gray-600 mb-4 line-clamp-2">{service.excerpt}</p>
                    <div className="flex items-center gap-2 text-secondary font-semibold text-sm">
                      Detaylı Bilgi
                      <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </section>

          <section className="mt-12 md:mt-20 bg-primary text-white rounded-2xl p-8 md:p-12 text-center">
            <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6">Hangi Ürün Size Uygun?</h2>
            <p className="text-base md:text-xl mb-6 md:mb-8 max-w-2xl mx-auto">
              Uzman ekibimiz ihtiyacınıza en uygun tente veya pergola sistemini belirlemenize yardımcı olur
            </p>
            <a
              href="https://wa.me/905421821925?text=Merhaba,%20bana%20uygun%20tente%20modelini%20öğrenmek%20istiyorum"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white text-primary px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-bold hover:bg-gray-100 transition-all cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-xl md:text-2xl"></i>
              Ücretsiz Danışmanlık Alın
            </a>
          </section>
        </div>
      </main>

      <Footer />
      <CookieBanner />

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center p-4 cursor-pointer"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white text-2xl transition-colors"
            onClick={closeLightbox}
            aria-label="Kapat"
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={lightboxImage}
            alt="Büyütülmüş görsel"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
